export default class Article {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        this.throttled = false;

        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $(window).on("load", function() {
            var articlesLength = $(".newsroom__all-article").length;
            if (articlesLength > 3) {
                $(".article__widget").addClass("article__widget--large");
            } else if (articlesLength == 3) {
                $(".article__widget").addClass("article__widget--tiny");
            } else if (articlesLength < 3) {
                $(".article__widget").addClass("article__flex-widget");
                $(".article__flex-widget").removeClass("article__widget");
            }

            $(".article__widget").slick(
                {
                    nextArrow: ".build__btn--next",
                    prevArrow: ".build__btn--previous",
                    infinite: true,

                    rows: 1,
                    slidesToShow:
                        articlesLength > 3 ? 3 : articlesLength <= 2 ? 1 : 2,
                    slidesToScroll: 1,

                    responsive: [
                        {
                            breakpoint: 1026,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true
                            }
                        },
                        {
                            breakpoint: 924,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: true,
                                autoplay: true
                            }
                        },
                        {
                            breakpoint: 700,
                            settings: "unslick"
                        }
                    ]
                },
                $(".article__widget").addClass("article__widget--loaded")
            );
            checkSize();

            if (articlesLength < 3) {
                $(".article__widget").slick("unslick");
                $(".article__widget").removeClass("column");
                $(".article__footer-read-more .build__buttons").hide();
            }
        });

        $(function() {
            $(".article__column  img").wrap(
                '<div class="article__img-box"></div>'
            );
            $(".article__img-box").append(
                `<img src="/images/newsroom/velky_pattern.png" alt="" class="article__cover-pattern">`
            );
            for (let i = 2; i <= 6; i++) {
                $(`.article__container h${i}`).addClass(
                    `typo-d${i + 1} article__text-heading`
                );
            }
        });
        $(window).resize(function() {
            if (!this.throttled) {
                // actual callback action
                checkSize();
                // we're throttled!
                this.throttled = true;
                // set a timeout to un-throttle
                setTimeout(function() {
                    throttled = false;
                }, 100);
            }
        });
        function runSlick() {
            var articlesLength = $(".newsroom__all-article").length;

            if (articlesLength >= 3) {
                $(".article__widget").slick({
                    nextArrow: ".build__btn--next",
                    prevArrow: ".build__btn--previous",
                    infinite: true,

                    rows: 1,
                    slidesToShow:
                        articlesLength > 3 ? 3 : articlesLength <= 2 ? 1 : 2,
                    slidesToScroll: 1,

                    responsive: [
                        {
                            breakpoint: 1026,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true
                            }
                        },
                        {
                            breakpoint: 950,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: true
                            }
                        },
                        {
                            breakpoint: 700,
                            settings: "unslick"
                        }
                    ]
                });
            }
        }
        function checkSize() {
            var width = $(window).width();
            if (width < 422) {
                $(".article__container").addClass("row");
            } else {
                $(".article__container").removeClass("row");
            }
            if (width < 700) {
                $(".newsroom__detail-read-more").each(function(index, el) {
                    if (index > 2) {
                        $(el).css({ display: "none" });
                    }
                });
            }
            if (width > 700) {
                if (!$(".article__widget").hasClass("slick-initialized")) {
                    runSlick();
                }
            }
        }
    }
}
